/**
 * Convert arbitrary text to a URL-safe slug.
 * @param {string} text
 * @returns {string}
 */
export function slugify(text) {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/**
 * Generate a deterministic job name from a source type and a connection name.
 * @param {{ name: string }} sourceType
 * @param {string} connectionName
 * @returns {string}
 */
export function generateJobName(sourceType, connectionName) {
  return `${slugify(sourceType.name)}-${slugify(connectionName)}`;
}

/**
 * Mask a credential value, showing only the last `visibleChars` characters.
 * @param {string} value
 * @param {number} visibleChars
 * @returns {string}
 */
export function maskCredential(value, visibleChars = 4) {
  if (!value) return "—";
  if (value.length <= visibleChars) return "••••";
  const visible = value.slice(-visibleChars);
  return "••••••••" + visible;
}
